export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-mail-send-line text-sm"></i>
              联络通道
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              有任何建议、投稿或合作意向，欢迎随时与我们取得联系
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-4xl mx-auto">
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-300 transition-all">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                <i className="ri-mail-line text-2xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">商务合作</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                版权合作、内容授权与商业推广
              </p>
              <span className="text-sm font-medium text-primary-600">cooperation@qinqinmanga.com</span>
            </div>

            <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-300 transition-all">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className="ri-chat-smile-2-line text-2xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">用户反馈</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                意见反馈、功能建议与问题报告
              </p>
              <span className="text-sm font-medium text-accent-600">feedback@qinqinmanga.com</span>
            </div>

            <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-300 transition-all">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                <i className="ri-quill-pen-line text-2xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">内容投稿</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                原创漫画投稿、译者招募
              </p>
              <span className="text-sm font-medium text-secondary-600">submit@qinqinmanga.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}